import { environment } from 'src/environments/environment'

import { DexIdentityProvider } from './dex-identity.provider'
import { IdentityProvider } from './identity-provider.interface'
import { KeycloakIdentityProvider } from './keycloak-identity.provider'

export interface CompanyConfigForIdentity {
  providerType?: 'keycloak' | 'dex'
  keycloakUrl?: string
  realmName?: string
  keycloakAppClientId?: string
  oidcIssuerUrl?: string
  oidcClientId?: string
  // When true, app owns the session — disables Keycloak's SSO-sync so provider
  // and app sessions can't override each other.
  appSessionsEnabled?: boolean
}

/** Prefers providerType + oidcIssuerUrl; falls back to legacy Keycloak fields. */
export function createIdentityProvider(config: CompanyConfigForIdentity): IdentityProvider {
  const providerType = config.providerType ?? 'keycloak'

  if (providerType === 'dex') {
    const authority = config.oidcIssuerUrl
    if (!authority) {
      throw new Error('Dex provider configured but oidcIssuerUrl is missing in /company/config response')
    }
    // Browser PKCE needs the SPA (public) client; config.oidcClientId is the
    // backend's confidential client. Pin redirectUri to tenant root — Dex
    // exact-matches redirectURIs, so deep routes would break logout.
    const tenantRoot = `${window.location.origin}/${environment.subdomain || ''}`
    return new DexIdentityProvider({
      authority,
      clientId: environment.keycloakClientId,
      redirectUri: tenantRoot,
      postLogoutRedirectUri: tenantRoot
    })
  }

  // Use the SPA (public) client id; config.oidcClientId is the backend's confidential client.
  return new KeycloakIdentityProvider({
    url: config.keycloakUrl ?? environment.keycloakBaseUrl,
    realm: config.realmName ?? environment.keycloakRealm,
    clientId: environment.keycloakClientId ?? config.keycloakAppClientId,
    appSessionsEnabled: config.appSessionsEnabled
  })
}
